import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Close } from "@styled-icons/remix-fill";
import styled from "styled-components";

const CloseButton = styled(Close)`
  color: white;
`;
export default function ConfirmationModal({
  closeModal,
  blockchainName,
  address,
  amount,
  events,
  closeMainModal
}: any) {
  return (
    <Fragment>
      <div className="">
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-visible rounded-2xl bg-gray-700 p-6 text-left align-middle shadow-xl transition-all">
                <div className="py-1 flex static">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-white"
                  >
                    Confirm Transaction Details
                  </Dialog.Title>

                  <button className="absolute right-5" onClick={closeModal}>
                    <CloseButton size={"24"} />
                  </button>
                </div>

                <div className="">
                  <p className="text-sm text-white mt-4">
                    Selected blockchain: {blockchainName}
                  </p>
                  <p className="text-sm text-white mt-4">
                    Destination Address: {address}
                  </p>
                  <p className="text-sm text-white mt-4">
                    Amount to transfer: ${amount}
                  </p>
                </div>

                <div className="flex justify-center">
                  <button
                    type="button"
                    className="mt-6 rounded-md bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                    onClick={() => {
                      events.trigger.bind(events)("withdraw", {
                        address,
                        blockchainName,
                        amount: {
                          crypto: "",
                          fiat: {
                            currency: "usd",
                            amount,
                          },
                        },
                      });
                      closeModal();
                      closeMainModal();
                    }}
                  >
                    Confirm withdrawal
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
